import React from 'react';

import { useStoreContext } from 'features/store';
import { useIntl } from 'react-intl';
import { Image, StyleSheet } from 'react-native';

import { routes } from 'utils/routing';

import {
  EmptyScreenWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const friesImage = require('./fries.png');

const OffersEmptyScreen: React.FC = () => {
  const { formatMessage } = useIntl();
  const { noStoreSelected } = useStoreContext();
  // Texts and link path change depending on store is select or not
  const headerText = noStoreSelected ? 'offersNoLocationSelected' : 'offersNoOffersAvailable';
  const subHeaderText = noStoreSelected
    ? 'offersSelectStoreToViewOffers'
    : 'offersYouCanStillEnjoyYourFavorites';
  const linkText = noStoreSelected ? 'offersSelectStore' : 'orderNow';
  const linkPath = noStoreSelected ? routes.storeLocator : routes.menu;

  return (
    <EmptyScreenWrapper>
      <ImageWrapper>
        <Image style={styles.image} source={friesImage} />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: headerText })}</HeaderText>
      <SubText>{formatMessage({ id: subHeaderText })}</SubText>
      <StyledActionButtonLink to={linkPath}>
        {formatMessage({ id: linkText })}
      </StyledActionButtonLink>
    </EmptyScreenWrapper>
  );
};

const styles = StyleSheet.create({
  image: {
    width: 300,
    height: 300,
  },
});

export default OffersEmptyScreen;
